<template>
  <!-- 导出国家级报告 -->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" ref="pdfContent">
      <!-- PDF  首页 -->
      <div class="HomePage page-box">
        <div id="image"></div>
        <div id="PdfTitle">
          <p id="FristTitle">国家职业教育智慧教育平台专业与课程服务中心</p>
        <span v-show="false">这是completeNum的值：{{completeNum  }}</span>
          <input id="completeNum" v-model="completeNum" v-show="false" />
          <div>
            <p id="SecondTitle" v-if="reportType == 1">建设及应用监测月度分析报告</p>
            <p id="SecondTitle" v-if="reportType == 2">建设及应用监测季度分析报告</p>
            <p id="SecondTitle" v-if="reportType == 3">建设及应用监测年度分析报告</p>
          </div>
          <p id="ThrendTitle" v-if="reportType == 1">（{{ nowYear }}年{{ nowMonth }}月）</p>
          <p id="ThrendTitle" v-if="reportType == 2">（{{ nowYear }}年{{ Quarter }}）</p>
          <p id="ThrendTitle" v-if="reportType == 3">（{{ nowYear }}年）</p>
          <p id="FourTitle">运行分析起止时间：{{ startDay }} 至 {{ endDay }}</p>
        </div>
        <div id="foot">
          <div class="footBox">
            <p>国家职业教育智慧教育平台专业与课程服务中心监测平台项目组</p>
            <p>广东轻工职业技术学院产教融合大数据研究所</p>
            <p>
              <span v-if="nowMonth != '12'">{{ nowYear }}年</span>
              <span v-else>{{ +nowYear + 1 }}年</span>
              <span v-if="nowMonth != '12'">{{ +nowMonth + 1 }}</span
              ><span v-else>1</span> 月 10 日
            </p>
          </div>
        </div>
      </div>

      <div class="catalogue page-box">
        <div class="title">
          <p style="font-size: 60px">
            目&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录
          </p>
        </div>
        <h5>1. 监测总览<span class="dot"></span>1</h5>
        <h5 class="Second_text">1.1 总体建设及应用情况<span class="dot"></span>1</h5>
        <div class="Thred_text">
          <h5>1.1.1 用户建设及应用情况<span class="dot"></span>1</h5>
          <h5>1.1.2 课程建设及应用情况<span class="dot"></span>2</h5>
          <h5>1.1.3 资源建设及应用情况<span class="dot"></span>3</h5>
        </div>
        <h5 class="Second_text">1.2 各省建设及应用情况<span class="dot"></span>4</h5>
        <div class="Thred_text">
          <h5>1.2.1 各省用户建设及应用情况<span class="dot"></span>4</h5>
          <h5>1.2.2 各省课程建设及应用情况<span class="dot"></span>5</h5>
          <h5>1.2.3 各省资源建设及应用情况<span class="dot"></span>5</h5>
        </div>
        <h5 class="Second_text">
          1.3 {{ startDay }}至{{ endDay }}运行监测分析<span class="dot"></span>6
        </h5>
        <div class="Thred_text">
          <h5>
            1.3.1 {{ startDay }}至{{ endDay }}用户建设及应用总体情况<span class="dot"></span>6
          </h5>
          <h5>
            1.3.2 {{ startDay }}至{{ endDay }}课程建设及应用总体情况<span class="dot"></span>7
          </h5>
          <h5>
            1.3.3 {{ startDay }}至{{ endDay }}资源建设及应用总体情况<span class="dot"></span>7
          </h5>
        </div>
        <h5>2.职业教育专业教学资源库建设及应用情况<span class="dot"></span>8</h5>
        <h5 class="Second_text">2.1 资源库建设及应用总体情况<span class="dot"></span>8</h5>
        <div class="Thred_text">
          <h5>2.1.1 用户建设及应用情况<span class="dot"></span>8</h5>
          <h5>2.1.2 课程建设及应用情况<span class="dot"></span>9</h5>
          <h5>2.1.3 资源建设及应用情况<span class="dot"></span>10</h5>
          <h5>2.1.4 国家级资源库建设及应用情况<span class="dot"></span>10</h5>
        </div>
        <h5 class="Second_text">2.2. 各省建设及应用情况<span class="dot"></span>12</h5>
        <div class="Thred_text">
          <h5>2.2.1 各省用户建设及应用情况<span class="dot"></span>12</h5>
          <h5>2.2.2 各省课程建设及应用情况<span class="dot"></span>13</h5>
        </div>
      </div>

      <div class="catalogue page-box">
        <div class="Thred_text">
          <h5>2.2.3 各省资源建设及应用情况<span class="dot"></span>13</h5>
        </div>
        <h5 class="Second_text">
          2.3 {{ startDay }}至{{ endDay }}资源库运行监测分析<span class="dot"></span>14
        </h5>
        <div class="Thred_text">
          <h5>
            2.3.1 {{ startDay }}至{{ endDay }}资源库用户建设及应用情况<span class="dot"></span>14
          </h5>
          <h5>
            2.3.2 {{ startDay }}至{{ endDay }}资源库课程建设及应用情况<span class="dot"></span>15
          </h5>
          <h5>
            2.3.3 {{ startDay }}至{{ endDay }}资源库资源建设及应用情况<span class="dot"></span>16
          </h5>
          <h5>
            2.3.4 {{ startDay }}至{{ endDay }}国家级资源库建设及应用情况<span class="dot"></span>17
          </h5>
        </div>
        <h5>3. 在线精品课建设及应用情况<span class="dot"></span>11</h5>
        <h5 class="Second_text">3.1 各省在线精品课建设情况<span class="dot"></span>21</h5>
        <h5 class="Second_text">3.2 在线精品课访问情况<span class="dot"></span>21</h5>
        <h5 class="Second_text">3.3 在线精品课开课情况<span class="dot"></span>22</h5>
        <h5 class="Second_text">3.4 在线精品课选课情况<span class="dot"></span>22</h5>
        <h5>4. 视频公开课建设及应用情况<span class="dot"></span>23</h5>
        <h5 class="Second_text">4.1 各省视频公开课建设情况<span class="dot"></span>23</h5>
        <h5 class="Second_text">4.2 视频公开课访问情况<span class="dot"></span>23</h5>
        <h5 class="Second_text">4.3 视频公开课选课情况<span class="dot"></span>24</h5>
      </div>

      <div class="chart_box page-box">
        <div class="header_titles">
          <h1>国家职业教育智慧教育平台专业与课程服务中心</h1>
          <h1 style="margin-top: 15px" v-if="reportType == 1">
            {{ nowYear }}年{{ nowMonth }}月建设及应用监测分析报告
          </h1>
          <h1 style="margin-top: 15px" v-if="reportType == 2">
            {{ nowYear }}年{{ Quarter }}建设及应用监测分析报告
          </h1>
          <h1 style="margin-top: 15px" v-if="reportType == 3">
            {{ nowYear }}年建设及应用监测分析报告
          </h1>
          <div class="number_time">
            <div>
              <span></span>
              <span>统计时间：{{ startDay }} 至 {{ endDay }}</span>
            </div>
            <p></p>
            <p></p>
          </div>
        </div>
        <div class="division">1. 监测总览</div>
        <p>
          自2022年03月28日开始，国家职业教育智慧教育平台专业与课程服务中心上线，专业与课程服务中心监测平台（以下简称“监测平台”）随即开始对专业教学资源库、
          在线精品课及视频公开课进行运行监测并提供数据分析服务。
        </p>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，监测平台共接入专业教学资源库{{
            overviewData.zykNum
          }}个，在线精品课{{ overviewData.onlineCourseNum }}门，视频公开课{{
            overviewData.videoCourseNum
          }}门， 覆盖平台数{{
            platformNum.allPlatform
          }}个（包括专业教学资源库、国家级在线精品课和视频公开课的支撑平台）。专业与课程服务中心累计用户访问量达{{
            getUtils_Fun(overviewData.totalVisitNum)
          }}次，用户数{{ getUtils_Fun(overviewData.userTotal) }}人；参与建设的院校有{{
            overviewData.schoolNum
          }}所；参建企业有{{ overviewData.companyNum }}家；覆盖专业数{{
            overviewData.totalProfessionCount
          }}个，其中职教本科专业数{{ overviewData.zjbk_edu }}个，高职专业数{{
            overviewData.height_edu
          }}个，中职专业数{{ getUtils_Fun(overviewData.middle_edu) }}个。
        </p>
        <h4>1.1 总体建设及应用情况</h4>
        <h5 style="margin-top: 0">1.1.1 用户建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
            getUtils_Fun(userBuildApply.total)
          }}人，其中学生总数最多，共{{ getUtils_Fun(userBuildApply.studentNum) }}人，占比{{
            ((userBuildApply.studentNum / userBuildApply.total) * 100).toFixed(2)
          }}%， 其次是教师，共{{ getUtils_Fun(userBuildApply.teacherNum) }}人，占比{{
            ((userBuildApply.teacherNum / userBuildApply.total) * 100).toFixed(2)
          }}%。具体情况如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="userBuildApply.pieDataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图1 用户类型分布</div>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，近一年学生用户访问总量达{{
            getUtils_Fun(userBuildApply.studentTotal)
          }}次，教师用户访问量达{{
            getUtils_Fun(userBuildApply.teacherTotal)
          }}次，具体访问趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="userBuildApply.lineDataList"
            :transverseData="userBuildApply.transverse"
            :colorList="colorList"
            :innerText="'单位：次'"
            :legendList="['教师', '学生']"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">图2 最近一年教师和学生访问情况</div>
      </div>

      <div class="chart_box page-box">
        <h5>1.1.2 课程建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，专业与课程服务中心共计{{
            getUtils_Fun(courseBuildApply.courseTotal)
          }}门课程，其中{{ courseBuildApply.maxObj.name }}量最多，占比{{
            ((courseBuildApply.maxObj.value / courseBuildApply.courseTotal) * 100).toFixed(2)
          }}%，具体课程来源分布如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="courseBuildApply.pieDataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图3 课程来源分布</div>
        <p class="m-top50">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，近一年课程被访问总量达{{
            getUtils_Fun(courseBuildApply.total)
          }}次，平均月访问量达{{
            getUtils_Fun(courseBuildApply.total / 12)
          }}次，具体访问趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="courseBuildApply.lineDataList"
            :transverseData="courseBuildApply.transverse"
            :colorList="colorList"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          >
          </discountChart>
        </div>
        <div class="chart_name">图4 近一年课程被访问趋势图</div>
        <p class="m-top50">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，课程被访问总量已达{{
            getUtils_Fun(courseBuildApply.courseVisitNum)
          }}次，依据专业与课程服务中心监测平台统计，被访问量居首的课程是《{{
            courseBuildApply.maxCourse.courseName
          }}》，有{{
            getUtils_Fun(courseBuildApply.maxCourse.courseTotalVisit)
          }}次，具体课程被访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表1 课程被访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程来源</th>
              <th>课程负责人</th>
              <th>建设院校</th>
              <th>访问量（次）</th>
            </tr>
            <tr v-if="courseBuildApply.tableList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
            <tr v-else v-for="(item, index) in courseBuildApply.tableList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.courseName }}</td>
              <td>{{ item.courseType }}</td>
              <td>{{ item.majorTeacher }}</td>
              <td>{{ item.schoolName }}</td>
              <td>{{ item.courseTotalVisit }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <h5>1.1.3 资源建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，专业与课程服务中心资源总数达{{
            getUtils_Fun(resourceBuildApply.total)
          }}条，共计容量有{{
            (resourceBuildApply.resourceCapacityNum / 1024 / 1024).toFixed(0)
          }}TB。 从资源类型来看，{{ resourceBuildApply.maxObj.name }}类数量最多，有{{
            getUtils_Fun(resourceBuildApply.maxObj.value)
          }}条，占比{{
            ((resourceBuildApply.maxObj.value / resourceBuildApply.total) * 100).toFixed(2)
          }}%，具体资源类型分布如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="resourceBuildApply.pieDataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :showValue="true"
            :unit="'条'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图5 资源类型分布</div>
        <p class="m-top150">
          资源被访问总量已达{{
            getUtils_Fun(resourceBuildApply.resourceTotal)
          }}次，其中访问次数最多的资源是《{{
            resourceBuildApply.maxResource
          }}》，资源被访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表2 资源被访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源名称</th>
              <th>资源来源</th>
              <th>建设院校</th>
              <th>访问量（次）</th>
            </tr>
            <tr v-if="resourceBuildApply.tableList.length === 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr v-else v-for="(item, index) in resourceBuildApply.tableList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.school }}</td>
              <td>{{ item.num }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="chart_box page-box">
        <h4>1.2 各省建设及应用情况</h4>
        <h5 style="margin-top: 0">1.2.1 各省用户建设及应用情况</h5>
        <p v-if="provinceUserBuildApply.studyUserNumRank.value.length > 0">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
            getUtils_Fun(provinceUserBuildApply.userTotal)
          }}人，来自29个省份，其中注册用户最多的是{{
            changeCity(provinceUserBuildApply.studyUserNumRank.name[0])
          }}， 达{{
            getUtils_Fun(provinceUserBuildApply.studyUserNumRank.value[0])
          }}之多；活跃用户总数有{{
            getUtils_Fun(provinceUserBuildApply.userRankInfoTotal)
          }}人，活跃用户数最多的是{{
            changeCity(provinceUserBuildApply.userRankInfo.name[0])
          }}，共{{
            getUtils_Fun(provinceUserBuildApply.userRankInfo.value[0])
          }}人；互动交流次数累计{{
            getUtils_Fun(provinceUserBuildApply.InteractionRankInfoTotal)
          }}次，互动交流频次最多的是{{
            changeCity(provinceUserBuildApply.InteractionRankInfo.name[0])
          }}，达{{ getUtils_Fun(provinceUserBuildApply.InteractionRankInfo.value[0]) }}次。
        </p>
        <div class="standards_content echartsHeight m-top100" style="height: 540px">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="provinceUserBuildApply.studyUserNumRank.value.slice(0, 15)"
            :transverseData="provinceUserBuildApply.studyUserNumRank.name.slice(0, 15)"
            :colorList="colorList"
            :gridY="'4%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图6 各省注册用户数排名（前十五名）</div>
        <div class="standards_content echartsHeight m-top100" style="height: 540px">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="provinceUserBuildApply.userRankInfo.value.slice(0, 15)"
            :transverseData="provinceUserBuildApply.userRankInfo.name.slice(0, 15)"
            :colorList="colorList"
            :gridY="'4%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图7 各省活跃用户数排名（前十五名）</div>
        <div class="standards_content echartsHeight m-top100" style="height: 540px">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="provinceUserBuildApply.InteractionRankInfo.value.slice(0, 15)"
            :transverseData="provinceUserBuildApply.InteractionRankInfo.name.slice(0, 15)"
            :colorList="colorList"
            :gridY="'4%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图8 各省交流互动量排名（前十五名）</div>
      </div>

      <div class="chart_box page-box">
        <h5>1.2.2 各省课程建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，建设课程总数{{
            getUtils_Fun(provinceCourseBuildApply.totalCourse)
          }}门，其中建设课程数量最多的是{{
            changeCity(provinceCourseBuildApply.courseProvinceRanking.transverseData[0])
          }}， 总计建设{{
            getUtils_Fun(provinceCourseBuildApply.courseProvinceRanking.dataList[0])
          }}门课程。各省访问课程的总量达{{
            getUtils_Fun(provinceCourseBuildApply.totalReport)
          }}次，访问课程总量最多的是{{
            provinceCourseBuildApply.reportProvinceCourseRank.name[0]
          }}省。
        </p>
        <div class="standards_content echartsHeight" style="height: 540px">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="provinceCourseBuildApply.courseProvinceRanking.dataList.slice(0, 15)"
            :transverseData="
              provinceCourseBuildApply.courseProvinceRanking.transverseData.slice(0, 15)
            "
            :colorList="colorList"
            :gridY="'4%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图9 各省建设课程数量排名（前十五名）</div>
        <div class="standards_content echartsHeight m-top50" style="height: 540px">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="provinceCourseBuildApply.reportProvinceCourseRank.value.slice(0, 15)"
            :transverseData="provinceCourseBuildApply.reportProvinceCourseRank.name.slice(0, 15)"
            :colorList="colorList"
            :gridY="'4%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图10 各省访问课程数排名（前十五名）</div>
        <h5 class="m-top150">1.2.3 各省资源建设及应用情况</h5>
        <p v-if="provinceResourceBuildApply.resourceRanking">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，建设资源总数{{
            getUtils_Fun(provinceResourceBuildApply.resourceTotalCount)
          }}条，其中建设资源数量最多的是{{
            changeCity(provinceResourceBuildApply.resourceRanking.name[0])
          }}，有{{ getUtils_Fun(provinceResourceBuildApply.resourceRanking.value[0]) }}条。
          各省访问资源的总量达{{
            getUtils_Fun(provinceResourceBuildApply.totalReport)
          }}次，访问资源总量最多的是{{
            changeCity(provinceResourceBuildApply.provinceVisitResourceRank.name[0])
          }}。
        </p>
        <div class="standards_content echartsHeight" style="height: 540px">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="provinceResourceBuildApply.resourceRanking.value.slice(0, 15)"
            :transverseData="provinceResourceBuildApply.resourceRanking.name.slice(0, 15)"
            :colorList="colorList"
            :gridY="'4%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图11 各省建设资源数排名（前十五名）</div>
      </div>

      <div class="chart_box page-box">
        <div class="standards_content echartsHeight" style="height: 540px">
          <tcolumnarChart
            :refId="'coursesOfferedChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="provinceResourceBuildApply.provinceVisitResourceRank.value.slice(0, 15)"
            :transverseData="provinceResourceBuildApply.provinceVisitResourceRank.name.slice(0, 15)"
            :colorList="colorList"
            :gridY="'4%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name" style="margin-top: 0">图12 各省访问资源数排名（前十五名）</div>
        <h4>1.3 {{ startDay }}至{{ endDay }}运行监测分析</h4>
        <h5 style="margin-top: 0">1.3.1 {{ startDay }}至{{ endDay }}用户建设及应用总体情况</h5>
        <p>
          在该时间段内，新增注册用户累计{{
            getUtils_Fun(userRunAnalysis.registerUserTotal)
          }}人，其中教师{{ getUtils_Fun(userRunAnalysis.teacherTotal) }}人，学生{{
            getUtils_Fun(userRunAnalysis.studentTotal)
          }}人，企业用户{{ getUtils_Fun(userRunAnalysis.enterpriseTotal) }}人，社会学习者{{
            getUtils_Fun(userRunAnalysis.socialTotal)
          }}人。注册用户趋势图如下所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'visitsMonthChart'"
            :datas="userRunAnalysis.stuAndTeach.dataList"
            :transverseData="userRunAnalysis.stuAndTeach.legend"
            :colorList="colorList"
            :legendList="['学生', '教师']"
            :innerText="'单位：人'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="standards_content echartsHeight m-top100">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'visitsMonthChart'"
            :datas="userRunAnalysis.socialAndEnter.dataList"
            :transverseData="userRunAnalysis.socialAndEnter.legend"
            :colorList="colorList"
            :legendList="['社会学习者', '企业用户']"
            :innerText="'单位：人'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图13 {{ startDay }}至{{ endDay }}注册用户趋势图</div>
        <p class="m-top100">
          在该时间段内，用户访问总量累计达{{
            getUtils_Fun(userRunAnalysis.userVisitsTotal)
          }}次，用户访问趋势图如下所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="userRunAnalysis.userVisits.value"
            :transverseData="userRunAnalysis.userVisits.name"
            :colorList="colorList"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name" style="margin-top: 0">
          图14 {{ startDay }}至{{ endDay }}用户访问趋势图
        </div>
      </div>

      <div class="chart_box page-box">
        <h5>1.3.2 {{ startDay }}至{{ endDay }}课程建设及应用总体情况</h5>
        <p>
          在该时间段内，新增课程数为{{
            getUtils_Fun(courseRunAnalysis.courseNewTotal)
          }}门，课程被访问次数达{{
            getUtils_Fun(courseRunAnalysis.courseVisitsTotal)
          }}次，课程运行趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="courseRunAnalysis.courseNew.value"
            :transverseData="courseRunAnalysis.courseNew.name"
            :colorList="colorList"
            :colorName="1"
            :innerText="'单位：门'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图15 {{ startDay }}至{{ endDay }}新增课程趋势图</div>
        <div class="standards_content echartsHeight m-top50">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="courseRunAnalysis.courseVisits.value"
            :transverseData="courseRunAnalysis.courseVisits.name"
            :colorList="colorList"
            :colorName="1"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图16 {{ startDay }}至{{ endDay }}课程被访问趋势图</div>
        <h5>1.3.3 {{ startDay }}至{{ endDay }}资源建设及应用总体情况</h5>
        <p>
          在该时间段内，新增资源数累计{{
            getUtils_Fun(resourceRunAnalysis.resourceNewTotal)
          }}条，资源被访问次数累计达{{
            getUtils_Fun(resourceRunAnalysis.resourceVisitsTotal)
          }}次，资源运行趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="resourceRunAnalysis.resourceNew.value"
            :transverseData="resourceRunAnalysis.resourceNew.name"
            :colorList="colorList"
            :innerText="'单位：条'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图17 {{ startDay }}至{{ endDay }}新增资源趋势图</div>
        <div class="standards_content echartsHeight m-top50">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="resourceRunAnalysis.resourceVisits.value"
            :transverseData="resourceRunAnalysis.resourceVisits.name"
            :colorList="colorList"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图18 {{ startDay }}至{{ endDay }}资源被访问趋势图</div>
      </div>

      <div class="chart_box page-box">
        <div class="division">2. 职业教育专业教学资源库建设及应用情况</div>
        <h4 style="margin-top: 0">2.1 资源库建设及应用总体情况</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，职业教育专业教学资源库已纳入监测项目共计{{
            zykBuildApply.totalZykNum
          }}个，其中国家级资源库共计{{ zykBuildApply.countryLevelZykNum }}个，省市级资源库共计{{
            zykBuildApply.provinceLevelZykNum
          }}个，院校级资源库共计{{ zykBuildApply.schoolLevelZykNum }}个，覆盖了{{
            zykBuildApply.professionBigClassNum
          }}个专业大类。 目前，已有{{ zykBuildApply.schoolBuildNum }}所职业院校和{{
            zykBuildApply.companyBuildNum
          }}家行业企业参与建设；标准化课程总量已达{{
            getUtils_Fun(zykBuildApply.standardNum)
          }}门，资源总量达{{ getUtils_Fun(zykBuildApply.resourceNum) }}余条，共有注册用户{{
            getUtils_Fun(zykBuildApply.zykUserNum)
          }}余人，总访问量{{ getUtils_Fun(zykBuildApply.totalZykVisitNum) }}次，支撑平台数{{
            platformNum.zykPlatform
          }}个，形成了国家、省、学校三级互补的优质资源共建共享体系，有力地推动了信息技术在职业教育专业教学和职业培训领域综合应用。具体建设及应用情况分析如下：
        </p>
        <h5>2.1.1 用户建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库共有注册用户{{
            getUtils_Fun(zykUserBuildApply.totalUserCount)
          }}余人，按用户身份类型统计，教师{{ getUtils_Fun(zykUserBuildApply.teacher) }}余人，学生{{
            getUtils_Fun(zykUserBuildApply.studentSum)
          }}余人。资源库企业用户{{
            getUtils_Fun(zykUserBuildApply.enterprise)
          }}余人，能够较好地考虑了企业员工继续教育、技能提升的需求，
          合作企业实现了依托资源库开展员工继续教育培训；资源库共有社会学习者{{
            getUtils_Fun(zykUserBuildApply.social)
          }}余人，努力承担面向普通劳动者免费线上培训的社会责任。
        </p>
        <p>用户类型分布详情如下所示：</p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="zykUserBuildApply.userAll"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图19 资源库用户整体情况</div>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="zykUserBuildApply.studentType"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图20 资源库学生类型分布情况</div>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="zykUserBuildApply.stuAndTeachData"
            :transverseData="zykUserBuildApply.stuAndTeachTransverse"
            :colorList="colorList"
            :innerText="'单位：次'"
            :legendList="['教师', '学生']"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">图21 资源库最近一年教师和学生访问情况</div>
      </div>

      <div class="chart_box page-box">
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="zykUserBuildApply.socialAndEnterData"
            :transverseData="zykUserBuildApply.socialAndEnterTransverse"
            :colorList="colorList"
            :innerText="'单位：次'"
            :legendList="['社会学习者', '企业用户']"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">图22 资源库最近一年社会学习者和企业用户访问情况</div>
        <h5 class="m-top150">2.1.2 课程建设及应用情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库项目课程总量达到{{
            getUtils_Fun(zykCourseBuildApply.courseNum)
          }}门，其中个性化课程{{ getUtils_Fun(zykCourseBuildApply.personalNum) }}门，标准化课程{{
            getUtils_Fun(zykCourseBuildApply.standardNum)
          }}门。 其中，注册学生用户访问最多的课程是《{{
            zykCourseBuildApply.courseMaxCount.name &&
            zykCourseBuildApply.courseMaxCount.name.split("-")[0]
          }}》，属于“{{ zykCourseBuildApply.courseMaxCount.zykName }}资源库”。在{{
            zykCourseBuildApply.courseMaxCount.zykDiv
          }}%的资源库中，项目课程(标准化课程)数量超过10门，课程按类型分布详情如下：
        </p>
        <div class="standards_content echartsHeight" style="height: 540px">
          <tcolumnarChart
            :refId="'resourcesMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="zykCourseBuildApply.courseType.value"
            :transverseData="zykCourseBuildApply.courseType.name"
            :colorList="colorList"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图23 资源库课程整体情况</div>
        <div class="standards_content echartsHeight m-top150">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="zykCourseBuildApply.yearCourseVisit.value"
            :transverseData="zykCourseBuildApply.yearCourseVisit.name"
            :colorList="colorList"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图24 资源库最近一年课程被访问情况</div>
      </div>

      <div class="chart_box page-box">
        <h5>2.1.3 资源建设及应用情况</h5>
        <p v-if="zykResourceBuildApply.resourceTypeMap">
          资源库项目资源数量达{{ getUtils_Fun(zykResourceBuildApply.resourceNum) }}条，{{
            zykResourceBuildApply.resourceTypeMap.name[0]
          }}类数量最多，达到{{
            getUtils_Fun(zykResourceBuildApply.resourceTypeMap.value[0])
          }}条。除此之外，各资源库项目还开发了大量的实践教学资源，拥有{{
            getUtils_Fun(zykResourceBuildApply.xuniNum)
          }}条虚拟仿真资源。资源访问总量已达{{
            getUtils_Fun(zykResourceBuildApply.resourceTotal)
          }}余次。
        </p>
        <p>资源按类型分布详情如下：</p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="zykResourceBuildApply.pieDataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :showValue="true"
            :unit="'条'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          >
          </circularChart>
        </div>
        <div class="chart_name">图25 资源库资源整体情况</div>
        <div class="standards_content echartsHeight m-top50">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="zykResourceBuildApply.yearResourceVisit.value"
            :transverseData="zykResourceBuildApply.yearResourceVisit.name"
            :colorList="colorList"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
            :isaverage="true"
          >
          </discountChart>
        </div>
        <div class="chart_name">图26 资源库最近一年资源被访问情况</div>
        <h5 class="m-top100">2.1.4 国家级资源库建设及应用情况</h5>
        <h6>2.1.4.1 覆盖专业大类分析</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，国家级资源库覆盖{{
            coverProfession.dataList.length - 1
          }}个专业大类。从专业大类分布看，所属“{{
            coverProfession.dataList[0].name
          }}”资源库最多，占比达{{
            ((coverProfession.dataList[0].value / coverProfession.total) * 100).toFixed(2)
          }}%，具体分布如下图所示：
        </p>
        <div class="standards_content echartsHeight m-top100">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="coverProfession.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'25%'"
            :legendBackgroundColor="true"
            :legendLeft="'45%'"
            :circleSize="80"
            :seriesRight="'50%'"
            :showValue="true"
            :unit="'个'"
          ></circularChart>
        </div>
        <div class="chart_name" style="margin-top: 30px">图27 国家级资源库专业大类分布情况</div>
      </div>

      <div class="chart_box page-box">
        <h6>2.1.4.2 用户建设及应用情况</h6>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，国家级职业教育专业教学资源库共有注册用户{{
            getUtils_Fun(countryUserBuildApply.userNum)
          }}余人，按用户身份类型统计，教师{{
            getUtils_Fun(countryUserBuildApply.tearchNum)
          }}余人，学生{{ getUtils_Fun(countryUserBuildApply.studentNum) }}余人。资源库企业用户{{
            getUtils_Fun(countryUserBuildApply.EnterpriseNum)
          }}余人，能够较好地考虑了企业员工继续教育、技能提升的需求，
          合作企业实现了依托资源库开展员工继续教育培训；资源库共有社会学习者{{
            getUtils_Fun(countryUserBuildApply.socialNum)
          }}余人，努力承担面向普通劳动者免费线上培训的社会责任。
        </p>
        <p>用户类型分布详情如下所示：</p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="countryUserBuildApply.userAll"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图28 国家级资源库用户整体情况</div>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="countryUserBuildApply.studentType"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图29 国家级资源库学生类型分布情况</div>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="countryUserBuildApply.stuAndTeachData"
            :transverseData="countryUserBuildApply.stuAndTeachTransverse"
            :colorList="colorList"
            :innerText="'单位：次'"
            :legendList="['教师', '学生']"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">图30 国家级资源库最近一年教师和学生访问情况</div>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="countryUserBuildApply.socialAndEnterData"
            :transverseData="countryUserBuildApply.socialAndEnterTransverse"
            :colorList="colorList"
            :innerText="'单位：次'"
            :legendList="['社会学习者', '企业用户']"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          >
          </discountChart>
        </div>
        <div class="chart_name">图31 国家级资源库最近一年社会学习者和企业用户访问情况</div>
      </div>

      <div class="chart_box page-box">
        <h6>2.1.4.3 课程建设及应用情况</h6>
        <p v-if="countryCourseBuildApply.courseMaxCount">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，国家级职业教育专业教学资源库项目课程总量达到{{
            getUtils_Fun(countryCourseBuildApply.courseCountNum)
          }}门，其中标准化课程{{
            getUtils_Fun(countryCourseBuildApply.standardNum)
          }}门，个性化课程{{ getUtils_Fun(countryCourseBuildApply.personalNum) }}门。
          其中，注册学生用户访问最多的课程是《{{
            countryCourseBuildApply.courseMaxCount.name &&
            countryCourseBuildApply.courseMaxCount.name.split("-")[0]
          }}》，属于“{{ countryCourseBuildApply.courseMaxCount.zykName }}资源库”。在{{
            countryCourseBuildApply.courseMaxCount.zykDiv
          }}%的资源库中，项目课程(标准化课程)数量超过10门，课程按类型分布详情如下：
        </p>
        <div class="standards_content echartsHeight" style="height: 540px">
          <tcolumnarChart
            :refId="'resourcesMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="countryCourseBuildApply.courseType.value"
            :transverseData="countryCourseBuildApply.courseType.name"
            :colorList="colorList"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图32 国家级资源库课程整体情况</div>
        <div class="standards_content echartsHeight m-top150">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="countryCourseBuildApply.yearCourseVisit.value"
            :transverseData="countryCourseBuildApply.yearCourseVisit.name"
            :colorList="colorList"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
            :isaverage="true"
          >
          </discountChart>
        </div>
        <div class="chart_name">图33 国家级资源库最近一年课程被访问情况</div>
        <h6 class="m-top100">2.1.4.4 资源建设及应用情况</h6>
        <p v-if="countryResourceBuildApply.resourceTypeMap">
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，国家级职业教育专业教学资源库项目资源数量达{{
            getUtils_Fun(countryResourceBuildApply.resourceNum)
          }}条，{{ countryResourceBuildApply.resourceTypeMap.name[0] }}类数量最多，达到{{
            getUtils_Fun(countryResourceBuildApply.resourceTypeMap.value[0])
          }}条 。除此之外，各资源库项目还开发了大量的实践教学资源，拥有{{
            getUtils_Fun(countryResourceBuildApply.xuniNum)
          }}条虚拟仿真资源。资源访问总量已达{{
            getUtils_Fun(countryResourceBuildApply.resourceTotal)
          }}余次， 其中访问次数最多的资源是《{{
            countryResourceBuildApply.visitMaxResource.name
          }}》，属于“{{ countryResourceBuildApply.visitMaxResource.zykName }}”。
        </p>
        <p>资源按类型分布详情如下：</p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="countryResourceBuildApply.pieDataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :showValue="true"
            :unit="'条'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          >
          </circularChart>
        </div>
        <div class="chart_name">图34 国家级资源库资源类型分布情况</div>
      </div>

      <div class="chart_box page-box">
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="countryResourceBuildApply.yearResourceVisit.value"
            :transverseData="countryResourceBuildApply.yearResourceVisit.name"
            :colorList="colorList"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
            :isaverage="true"
          >
          </discountChart>
        </div>
        <div class="chart_name">图35 国家级资源库最近一年资源被访问情况</div>
        <h6 class="m-top100">2.1.4.5 国家级资源库应用排名情况</h6>
        <h6>2.1.4.5.1 按照访问量排名</h6>
        <p>
          国家级资源库项目中，“{{ countryVisitRank[0].zykName }}资源库”的访问量最多，紧随其后的是“{{
            countryVisitRank[1].zykName
          }}资源库”和“{{
            countryVisitRank[2].zykName
          }}资源库”。具体按照访问情况排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表3 国家级资源库访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库名称</th>
              <th>第一主持院校</th>
              <th>课程数（门）</th>
              <th>资源数（条）</th>
              <th>访问量（次）</th>
            </tr>
            <tr v-if="countryVisitRank.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
            <tr v-else v-for="(item, index) in countryVisitRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.schoolName }}</td>
              <td>{{ item.courseNum }}</td>
              <td>{{ item.resourceCount }}</td>
              <td>{{ item.logNum }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import distributionChart from "@/components/chart/distributionChart.vue"; // 地图
import pageToPDF from "@/utils/htmlToPdf.js";
export default {
  components: {
    circularChart,
    tcolumnarChart,
    discountChart,
    distributionChart,
  },
  data() {
    return {
      completeNum: 0, //统计接口数量
      year: "",
      colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"], // 柱状图或折线图的颜色
      loading: "", // 是否导出加载中
      startDay: "",
      endDay: "",
      // 现在的时间
      nowYear: "",
      nowMonth: "",
      nowDay: "",
      Quarter: "",
      reportType: null,
      header: {
        zykName: "",
        zykNum: "",
      },
      platformNum: {}, //平台数
      overviewData: {}, // 1. 监测总览
      // 1.1.1 用户建设及应用情况
      userBuildApply: {
        pieDataList: [], //饼图数据
        total: 0, //注册用户总数
        studentNum: 0, //学生数
        teacherNum: 0, //教师数
        studentTotal: 0, //学生总数
        teacherTotal: 0, //教师总数
        lineDataList: [], //折线图数据
        transverse: [], //折线图横坐标
      },
      // 1.1.2 课程建设及应用情况
      courseBuildApply: {
        pieDataList: [], //饼图数据
        lineDataList: [], //折线图数据
        transverse: [], //折线图横坐标
        courseTotal: 0,
        total: 0,
        courseVisitNum: 0,
        tableList: [],
        maxObj: {},
        maxCourse: {},
      },
      // 1.1.3 资源建设及应用
      resourceBuildApply: {
        pieDataList: [], //饼图数据
        tableList: [],
        total: 0,
        maxObj: {},
        resourceTotal: 0,
        maxResource: {},
      },
      // 1.2.1 各省用户建设及应用
      provinceUserBuildApply: {
        userTotal: 0,
        studyUserNumRank: {
          name: [],
          value: [],
        },
        userRankInfo: {
          name: [],
          value: [],
        },
        InteractionRankInfo: {
          name: [],
          value: [],
        },
      },
      // 1.2.2 各省课程建设及应用
      provinceCourseBuildApply: {
        courseProvinceRanking: {
          transverseData: [],
          dataList: [],
        },
        reportProvinceCourseRank: {
          name: [],
          value: [],
        },
      },
      // 1.2.3 各省资源建设及应用
      provinceResourceBuildApply: {
        resourceRanking: {},
      },
      //1.3.1 用户建设及应用总体情况
      userRunAnalysis: {
        stuAndTeach: {},
        socialAndEnter: {},
        userVisits: {},
      },
      //1.3.2 课程建设及应用总体情况
      courseRunAnalysis: {
        courseNew: {},
        courseVisits: {},
      },
      // 1.3.3 资源运行分析
      resourceRunAnalysis: {
        resourceNew: {},
        resourceVisits: {},
      },
      // 2.1 资源库建设及应用总体情况
      zykBuildApply: {},
      // 2.1.1 用户建设及应用情况
      zykUserBuildApply: {
        stuAndTeachData: [],
        stuAndTeachTransverse: [],
        socialAndEnterData: [],
        socialAndEnterTransverse: [],
      },
      // 2.1.2 课程建设及应用情况
      zykCourseBuildApply: {
        courseMaxCount: {},
        courseType: {},
        yearCourseVisit: {},
      },
      // 2.1.3 资源建设及应用情况
      zykResourceBuildApply: {
        visitMaxResource: {},
        yearResourceVisit: {},
      },
      //2.1.4.1 覆盖专业大类分析
      coverProfession: {
        dataList: [],
        total: 0,
      },
      countryUserBuildApply: {}, // 2.1.4.2 用户建设及应用情况
      countryCourseBuildApply: {}, // 2.1.4.3 课程建设及应用情况
      countryResourceBuildApply: {}, // 2.1.4.4 资源建设及应用情况
      countryVisitRank: [], // 2.1.4.5.1 按照访问量排名
    };
  },
  created() {
    if (this.$route.query) {
      let token = this.$route.query.token;
      this.startDay = this.$route.query.startDay;
      this.endDay = this.$route.query.endDay;
      this.nowYear = this.endDay.slice(0, 4);
      this.reportType = this.$route.query.type;
      if (
        this.startDay.indexOf("01-01") !== -1 &&
        this.endDay.indexOf("03-31") !== -1 &&
        this.reportType == 2
      ) {
        this.Quarter = "第1季度";
      } else if (
        this.startDay.indexOf("04-01") !== -1 &&
        this.endDay.indexOf("06-30") !== -1 &&
        this.reportType == 2
      ) {
        this.Quarter = "第2季度";
      } else if (
        this.startDay.indexOf("07-01") !== -1 &&
        this.endDay.indexOf("09-30") !== -1 &&
        this.reportType == 2
      ) {
        this.Quarter = "第3季度";
      } else if (
        this.startDay.indexOf("10-01") !== -1 &&
        this.endDay.indexOf("12-31") !== -1 &&
        this.reportType == 2
      ) {
        this.Quarter = "第4季度";
      }
      sessionStorage.setItem("lrmv2token", token);
      let zykid = this.$route.query.zykid;
      sessionStorage.setItem("zykId", zykid);
    }
    this.nowDate(); // 截取当前日期的赋值操作
    this.getPlatFormNumByType_fn(); //获取平台数
    this.getCountryMonthReportOverviewData(); // 1. 监测总览
    this.getUserBuildApplyCase(); // 1.1.1 用户建设及应用情况
    this.getCourseBuildApplyCase(); //1.1.2 课程建设及应用情况
    this.getResourceBuildApplyCase(); // 1.1.3 资源建设及应用
    this.getProvinceUserBuildApplyCase(); //1.2.1 各省用户建设及应用
    this.getProvinceCourseBuildApplyCase(); //1.2.2 各省课程建设及应用
    this.getProvinceResourceBuildApplyCase(); //1.2.3 各省资源建设及应用
    this.getUserRunAnalysisCase(); //1.3.1 用户建设及应用总体情况
    this.getCourseRunAnalysisCase(); //1.3.2 课程建设及应用总体情况
    this.getResourceRunAnalysisCase(); //1.3.3 资源运行分析
    this.getAllZykBuildAndAppAnalysisCase(); //2.1 资源库建设及应用总体情况
    this.getUserBuildAndAnalysisCase(); // 2.1.1 用户建设及应用分析
    this.getCourseBuildAndAnalysisCase(); // 2.1.2 课程建设及应用情况
    this.getResourceBuildAndAnalysisCase(); // 2.1.3 资源建设及应用情况
    this.getCoverProfessionList(); //2.1.4.1 覆盖专业大类分析
    this.getCountryUserBuildAnalysisCase(); // 2.1.4.2 用户建设及应用情况
    this.getCountryCourseBuildAnalysisCase(); // 2.1.4.3 课程建设及应用情况
    this.getCountryResourceBuildAnalysis(); // 2.1.4.4 资源建设及应用情况
    this.getCountryZykVisitLogRank(); // 2.1.4.5.1 按照访问量排名
  },
  watch: {
    completeNum(val) {
      console.log(val);
    },
  },
  methods: {
    // 截取当前日期的赋值操作
    nowDate() {
      let Frist = this.endDay.indexOf("-") + 1;
      let last = this.endDay.lastIndexOf("-") + 1;
      let regx = /^[0]+/;
      this.nowMonth = this.endDay.slice(Frist, last - 1).replace(regx, "");
      this.nowDay = this.endDay.slice(last, this.endDay.length);
    },

    getUtils_Fun(num) {
      const data =
        num > 100000000
          ? `${
              (num / 100000000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 100000000).toFixed(0)
                : (num / 100000000).toFixed(2)
            }亿`
          : num > 10000
          ? `${
              (num / 10000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 10000).toFixed(0)
                : (num / 10000).toFixed(2)
            }万`
          : num;
      return data;
    },

    // 导出pdf文件
    exportPdf() {
      const lableList = document.getElementsByClassName("page-box");
      pageToPDF(`国家端整体月报copy1`, this.$refs.pdfContent, lableList);
    },

    // 获取平台数
    getPlatFormNumByType_fn() {
      this.$axios.post(this.$apiurls.getPlatFormNumByType, { loading: false }).then((res) => {
        if (res.code === 200) {
          this.platformNum = res.data;
          this.completeNum = this.completeNum + 1;
        }
      });
    },

    // 1. 监测总览
    getCountryMonthReportOverviewData() {
      this.$axios
        .post(this.$apiurls.getCountryMonthReportOverviewData, {
          loading: false,
        })
        .then((res) => {
          this.overviewData = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 1.1.1 用户建设及应用情况
    getUserBuildApplyCase() {
      this.$axios.post(this.$apiurls.getUserBuildApplyCase, { loading: false }).then((res) => {
        let arr = [];
        let name = res.data.allReportUserForType.name;
        let value = res.data.allReportUserForType.value;
        let sum = 0;
        for (let i = 0; i < name.length; i++) {
          sum += value[i];
          arr.push({
            name: name[i],
            value: value[i],
          });
        }
        this.userBuildApply.pieDataList = arr;
        this.userBuildApply.total = sum;
        // 教师数量
        this.userBuildApply.teacherNum = arr.find((item) => item.name == "教师").value;
        // 学生数
        this.userBuildApply.studentNum = arr.find((item) => item.name == "学生").value;

        this.userBuildApply.studentTotal = res.data.userMonthVisits.studentTotal;
        this.userBuildApply.teacherTotal = res.data.userMonthVisits.teacherTotal;
        this.userBuildApply.lineDataList = [
          res.data.userMonthVisits.teacher.value,
          res.data.userMonthVisits.student.value,
        ];
        this.userBuildApply.transverse = res.data.userMonthVisits.student.name;
        this.completeNum = this.completeNum + 1;
      });
    },

    // 1.1.2 课程建设及应用情况
    getCourseBuildApplyCase() {
      this.$axios.post(this.$apiurls.getCourseBuildApplyCase, { loading: false }).then((res) => {
        let arr = [
          { name: "资源库课程数", value: res.data.zykCourseCount },
          { name: "在线精品课数", value: res.data.onlineCourseNum },
          { name: "视频公开课数", value: res.data.videoCourseNum },
        ];
        this.courseBuildApply.pieDataList = arr;
        function func(a, b) {
          return b.value - a.value;
        }
        this.courseBuildApply.maxObj = arr.sort(func)[0];
        let sum = 0;
        for (const item of arr) {
          sum += item.value;
        }
        this.courseBuildApply.courseTotal = sum;
        this.courseBuildApply.total = res.data.courseYearMonthVisits.courseTotal;
        this.courseBuildApply.lineDataList = res.data.courseYearMonthVisits.course.value;
        this.courseBuildApply.transverse = res.data.courseYearMonthVisits.course.name;
        this.courseBuildApply.courseVisitNum = res.data.courseVisitNum;
        this.courseBuildApply.tableList = res.data.courseVisitsRank;
        this.courseBuildApply.maxCourse = this.courseBuildApply.tableList[0];
        this.completeNum = this.completeNum + 1;
      });
    },

    // 1.1.3 资源建设及应用
    getResourceBuildApplyCase() {
      this.$axios.post(this.$apiurls.getResourceBuildApplyCase, { loading: false }).then((res) => {
        this.resourceBuildApply = res.data;
        let arr = [];
        let name = res.data.resourceTypes.name;
        let value = res.data.resourceTypes.value;
        let sum = 0;
        for (let i = 0; i < name.length; i++) {
          sum += value[i];
          arr.push({ name: name[i], value: value[i] });
        }
        this.resourceBuildApply.pieDataList = arr;
        this.resourceBuildApply.total = sum;
        function func(a, b) {
          return b.value - a.value;
        }
        this.resourceBuildApply.maxObj = arr.sort(func)[0];
        this.resourceBuildApply.resourceTotal = res.data.reportResourceRank.resourceTotal;
        this.resourceBuildApply.tableList = res.data.reportResourceRank.resourceRank;
        this.resourceBuildApply.maxResource =
          this.resourceBuildApply.tableList[0].name.split(",")[0];
        this.completeNum = this.completeNum + 1;
      });
    },

    // 1.2.1 各省用户建设及应用
    getProvinceUserBuildApplyCase() {
      this.$axios
        .post(this.$apiurls.getProvinceUserBuildApplyCase, { loading: false })
        .then((res) => {
          this.provinceUserBuildApply = res.data;
          let sum1 = 0;
          res.data.userRankInfo.value.forEach((item) => {
            sum1 += item;
          });
          this.provinceUserBuildApply.userRankInfoTotal = sum1;
          let sum2 = 0;
          res.data.InteractionRankInfo.value.forEach((item) => {
            sum2 += item;
          });
          this.provinceUserBuildApply.InteractionRankInfoTotal = sum2;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 1.2.2各省课程建设及应用
    getProvinceCourseBuildApplyCase() {
      this.$axios
        .post(this.$apiurls.getProvinceCourseBuildApplyCase, { loading: false })
        .then((res) => {
          this.provinceCourseBuildApply = res.data;
          let sum = 0;
          res.data.reportProvinceCourseRank.value.forEach((item) => {
            sum += item;
          });
          this.provinceCourseBuildApply.totalReport = sum;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 1.2.3 各省资源建设及应用
    getProvinceResourceBuildApplyCase() {
      this.$axios
        .post(this.$apiurls.getProvinceResourceBuildApplyCase, {
          loading: false,
        })
        .then((res) => {
          this.provinceResourceBuildApply = res.data;
          let data = res.data.resourceRanking;
          let name = [];
          let value = [];
          for (const item of data) {
            name.push(item.province);
            value.push(item.num);
          }
          this.provinceResourceBuildApply.resourceRanking = { name, value };
          let sum = 0;
          res.data.provinceVisitResourceRank.value.forEach((item) => {
            sum += item;
          });
          this.provinceResourceBuildApply.totalReport = sum;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 1.3.1 用户建设及应用总体情况
    getUserRunAnalysisCase() {
      this.$axios
        .post(
          this.$apiurls.getUserRunAnalysisCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          { loading: false }
        )
        .then((res) => {
          let data = res.data.countryReportUserMonthNew;
          this.userRunAnalysis.stuAndTeach.dataList = [data.student.value, data.teacher.value];
          this.userRunAnalysis.stuAndTeach.legend = data.student.name;
          this.userRunAnalysis.socialAndEnter.dataList = [data.social.value, data.enterprise.value];
          this.userRunAnalysis.socialAndEnter.legend = data.social.name;
          this.userRunAnalysis.studentTotal = data.student.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userRunAnalysis.teacherTotal = data.teacher.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userRunAnalysis.socialTotal = data.social.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userRunAnalysis.enterpriseTotal = data.enterprise.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userRunAnalysis.registerUserTotal =
            this.userRunAnalysis.studentTotal +
            this.userRunAnalysis.teacherTotal +
            this.userRunAnalysis.socialTotal +
            this.userRunAnalysis.enterpriseTotal;
          this.userRunAnalysis.userVisitsTotal = res.data.countryReportUserMonthVisits.value.reduce(
            function (a, b) {
              return a + b;
            },
            0
          );
          this.userRunAnalysis.userVisits = res.data.countryReportUserMonthVisits;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 1.3.2 课程建设及应用总体情况
    getCourseRunAnalysisCase() {
      this.$axios
        .post(
          this.$apiurls.getCourseRunAnalysisCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          { loading: false }
        )
        .then((res) => {
          this.courseRunAnalysis = res.data;
          this.courseRunAnalysis.courseNewTotal = res.data.courseNew.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.courseRunAnalysis.courseVisitsTotal = res.data.courseVisits.value.reduce(function (
            a,
            b
          ) {
            return a + b;
          },
          0);
          this.completeNum = this.completeNum + 1;
        });
    },

    // 1.3.3 资源运行分析
    getResourceRunAnalysisCase() {
      this.$axios
        .post(
          this.$apiurls.getResourceRunAnalysisCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          { loading: false }
        )
        .then((res) => {
          this.resourceRunAnalysis = res.data;
          this.resourceRunAnalysis.resourceNewTotal = res.data.resourceNew.value.reduce(function (
            a,
            b
          ) {
            return a + b;
          },
          0);
          this.resourceRunAnalysis.resourceVisitsTotal = res.data.resourceVisits.value.reduce(
            function (a, b) {
              return a + b;
            },
            0
          );
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1 资源库建设及应用总体情况
    getAllZykBuildAndAppAnalysisCase() {
      this.$axios
        .post(this.$apiurls.getAllZykBuildAndAppAnalysisCase, {
          loading: false,
        })
        .then((res) => {
          this.zykBuildApply = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.1 用户建设及应用分析
    getUserBuildAndAnalysisCase() {
      this.$axios
        .post(this.$apiurls.getUserBuildAndAnalysisCase, { loading: false })
        .then((res) => {
          this.zykUserBuildApply = res.data;
          let userMap = res.data.userMap;
          let arr = [
            {
              name: "学生",
              value: userMap.student,
            },
            {
              name: "教师",
              value: userMap.teacher,
            },
            {
              name: "社会学习者",
              value: userMap.social,
            },
            {
              name: "企业用户",
              value: userMap.enterprise,
            },
            {
              name: "其他",
              value: userMap.other,
            },
          ];
          this.zykUserBuildApply.userAll = arr;
          let userMonthVisits = res.data.userMonthVisits;
          this.zykUserBuildApply.stuAndTeachData = [
            userMonthVisits.teacher.value,
            userMonthVisits.student.value,
          ];
          this.zykUserBuildApply.stuAndTeachTransverse = userMonthVisits.student.name;
          this.zykUserBuildApply.socialAndEnterData = [
            userMonthVisits.social.value,
            userMonthVisits.enterprise.value,
          ];
          this.zykUserBuildApply.socialAndEnterTransverse = userMonthVisits.social.name;
          let sum = 0;
          res.data.studentType.forEach((item) => {
            sum += +item.value;
          });
          this.zykUserBuildApply.studentSum = sum;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.2 课程建设及应用情况
    getCourseBuildAndAnalysisCase() {
      this.$axios
        .post(this.$apiurls.getCourseBuildAndAnalysisCase, {
          loading: false,
        })
        .then((res) => {
          this.zykCourseBuildApply = res.data;
          let name = res.data.courseType.name;
          let value = res.data.courseType.value;
          let arr = [];
          for (let i = 0; i < value.length; i++) {
            arr.push({ name: name[i], value: value[i] });
          }
          this.zykCourseBuildApply.personalNum = arr.find(
            (item) => item.name === "个性化课程"
          ).value;
          this.zykCourseBuildApply.standardNum = arr.find(
            (item) => item.name === "标准化课程"
          ).value;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.3 资源建设及应用情况
    getResourceBuildAndAnalysisCase() {
      this.$axios
        .post(this.$apiurls.getResourceBuildAndAnalysisCase, {
          loading: false,
        })
        .then((res) => {
          res.data.visitMaxResource.name = res.data.visitMaxResource.name.split(",")[0];
          this.zykResourceBuildApply = res.data;
          let name = res.data.resourceTypeMap.name;
          let value = res.data.resourceTypeMap.value;
          let arr = [];
          for (let i = 0; i < value.length; i++) {
            arr.push({ name: name[i], value: value[i] });
          }
          this.zykResourceBuildApply.xuniNum = arr.find((item) => item.name === "虚拟仿真").value;
          this.zykResourceBuildApply.pieDataList = arr;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.4.1 覆盖专业大类分析
    getCoverProfessionList() {
      this.$axios
        .post(this.$apiurls.getCoverProfessionList, {
          loading: false,
        })
        .then((res) => {
          this.coverProfession.dataList = res.data;
          let sum = 0;
          res.data.forEach((item) => {
            sum += item.value;
          });
          this.coverProfession.total = sum;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.4.2 用户建设及应用情况
    getCountryUserBuildAnalysisCase() {
      this.$axios
        .post(this.$apiurls.getCountryUserBuildAnalysisCase, {
          loading: false,
        })
        .then((res) => {
          this.countryUserBuildApply = res.data;
          let name = res.data.userProfileMap.userProfileName;
          let value = res.data.userProfileMap.userProfileNum;
          let arr = [];
          for (let i = 0; i < name.length; i++) {
            arr.push({ name: name[i], value: value[i] });
          }
          this.countryUserBuildApply.userAll = arr;
          this.countryUserBuildApply.tearchNum = arr.find((item) => item.name === "教师").value;
            let sum = 0;
            res.data.studentType.forEach((item) => {
                sum += +item.value;
            });
          this.countryUserBuildApply.studentNum = sum;
          this.countryUserBuildApply.EnterpriseNum = arr.find(
            (item) => item.name === "企业用户"
          ).value;
          this.countryUserBuildApply.socialNum = arr.find(
            (item) => item.name === "社会学习者"
          ).value;
          let data = res.data.countryUserMonthVisits;
          this.countryUserBuildApply.stuAndTeachData = [data.teacher.value, data.student.value];
          this.countryUserBuildApply.stuAndTeachTransverse = data.teacher.name;
          this.countryUserBuildApply.socialAndEnterData = [
            data.social.value,
            data.enterprise.value,
          ];
          this.countryUserBuildApply.socialAndEnterTransverse = data.social.name;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.4.3 课程建设及应用情况
    getCountryCourseBuildAnalysisCase() {
      this.$axios
        .post(this.$apiurls.getCountryCourseBuildAnalysisCase, {
          loading: false,
        })
        .then((res) => {
          this.countryCourseBuildApply = res.data;
          let name = res.data.courseType.name;
          let value = res.data.courseType.value;
          let arr = [];
          for (let i = 0; i < value.length; i++) {
            arr.push({ name: name[i], value: value[i] });
          }
          this.countryCourseBuildApply.personalNum = arr.find(
            (item) => item.name === "个性化课程"
          ).value;
          this.countryCourseBuildApply.standardNum = arr.find(
            (item) => item.name === "标准化课程"
          ).value;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.4.4 资源建设及应用情况
    getCountryResourceBuildAnalysis() {
      this.$axios
        .post(this.$apiurls.getCountryResourceBuildAnalysis, {
          loading: false,
        })
        .then((res) => {
          res.data.visitMaxResource.name = res.data.visitMaxResource.name.split(",")[0];
          this.countryResourceBuildApply = res.data;
          let name = res.data.resourceTypeMap.name;
          let value = res.data.resourceTypeMap.value;
          let arr = [];
          for (let i = 0; i < value.length; i++) {
            arr.push({ name: name[i], value: value[i] });
          }
          this.countryResourceBuildApply.xuniNum = arr.find(
            (item) => item.name === "虚拟仿真"
          ).value;
          this.countryResourceBuildApply.pieDataList = arr;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.4.5.1 按照访问量排名
    getCountryZykVisitLogRank() {
      this.$axios
        .post(this.$apiurls.getCountryZykVisitLogRank, {
          loading: false,
        })
        .then((res) => {
          this.countryVisitRank = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.4.5.2 按照用户活跃情况分析
    getCountryZykUserActiveAnalysis() {
      this.$axios
        .post(this.$apiurls.getCountryZykUserActiveAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.countryUserRank = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.1 各省用户建设及应用情况
    getProvinceUserBuildAnalysis() {
      this.$axios
        .post(this.$apiurls.getProvinceUserBuildAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.provinceUser = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.2 各省课程建设及应用情况
    getProvinceCourseBuildAnalysis() {
      this.$axios
        .post(this.$apiurls.getProvinceCourseBuildAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.provinceCourse = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.3 各省资源建设及应用情况
    getProvinceZyBuildAnalysis() {
      this.$axios
        .post(this.$apiurls.getProvinceZyBuildAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.provinceResource = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.1 资源库用户建设及应用情况 1. 用户新增情况
    getZykUserAddCase() {
      this.$axios
        .post(
          this.$apiurls.getZykUserAddCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          let data = res.data;
          this.userAddCase.dataList = [data.student.value, data.teacher.value];
          this.userAddCase.transverse = data.student.name;
          this.userAddCase.sTotal = data.student.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userAddCase.tTotal = data.teacher.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userAddCase.total = this.userAddCase.sTotal + this.userAddCase.tTotal;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.1 资源库用户建设及应用情况 2. 用户活跃情况
    getZykUserActiveCase() {
      this.$axios
        .post(
          this.$apiurls.getZykUserActiveCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userActiveCase = res.data;
          let sum = 0;
          res.data.userActive.forEach((item) => {
            sum += item.logNum;
          });
          this.userActiveCase.userVisitTotal = sum;
          this.userActiveCase.student = res.data.userActive.find((item) => item.role === "学生");
          this.userActiveCase.teacher = res.data.userActive.find((item) => item.role === "教师");
          this.userActiveCase.enterprise = res.data.userActive.find(
            (item) => item.role === "企业用户"
          );
          this.userActiveCase.social = res.data.userActive.find(
            (item) => item.role === "社会学习者"
          );
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.1 资源库用户建设及应用情况 3. 用户访问情况排名
    getUserVisitRank() {
      this.$axios
        .post(
          this.$apiurls.getUserVisitRank,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userVisitRank = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.2 资源库课程建设及应用情况
    getZykCourseBuildAnalysis() {
      this.$axios
        .post(
          this.$apiurls.getZykCourseBuildAnalysis,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.courseBuildAnalysis = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.3 资源库资源建设及应用情况
    getZykResourceBuildAnalysis() {
      this.$axios
        .post(
          this.$apiurls.getZykResourceBuildAnalysis,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.resourceBuildAnalysis = res.data;
          let data = res.data.resourceDistribution;
          this.resourceBuildAnalysis.pieDataList = [
            {
              name: "视频类",
              value: data.video,
            },
            {
              name: "动画类",
              value: data.animation,
            },
            {
              name: "图形图像类",
              value: data.image,
            },
            {
              name: "虚拟仿真类",
              value: data.simulation,
            },
            {
              name: "文本类",
              value: data.text,
            },
            {
              name: "微课类",
              value: data.microCourses,
            },
            {
              name: "音频类",
              value: data.audio,
            },
            {
              name: "ppt和富媒体等",
              value: data.ppt + data.courseware + data.media,
            },
            {
              name: "其他",
              value: data.other,
            },
          ];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.3.4.1 用户运行情况
    getCountryZykUserRunCase() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykUserRunCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userRunCase = res.data;
          // 1. 用户新增情况
          this.userRunCase.tTotal = res.data.userAddCase.teacher.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userRunCase.sTotal = res.data.userAddCase.student.value.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.userRunCase.userTotal = this.userRunCase.tTotal + this.userRunCase.sTotal;
          this.userRunCase.userAddDataList = [
            res.data.userAddCase.teacher.value,
            res.data.userAddCase.student.value,
          ];
          this.userRunCase.userAddTransverse = res.data.userAddCase.teacher.name;

          // 2. 用户活跃情况
          let sum = 0;
          res.data.userActiveCase.userActive.forEach((item) => {
            sum += item.logNum;
          });
          this.userRunCase.logTotal = sum;
          this.userRunCase.activeStudent = res.data.userActiveCase.userActive.find(
            (item) => item.role === "学生"
          );
          this.userRunCase.activeTeacher = res.data.userActiveCase.userActive.find(
            (item) => item.role === "教师"
          );
          this.userRunCase.activeEnterprise = res.data.userActiveCase.userActive.find(
            (item) => item.role === "企业用户"
          );
          this.userRunCase.activeSocial = res.data.userActiveCase.userActive.find(
            (item) => item.role === "社会学习者"
          );
          this.userRunCase.activeUserTotal = res.data.userActiveCase.userActiveTotal;
          this.userRunCase.userActiveLine = res.data.userActiveCase.userActiveMonthRole;
          this.completeNum = this.completeNum + 1;
        });
    },

    changeCity(data) {
      if (data) {
        if (data == "北京" || data == "上海" || data == "天津" || data == "重庆") {
          if (data.indexOf("市") === -1) return data + "市";
          else return data;
        } else {
          if (data.indexOf("省") === -1) return data + "省";
          else return data;
        }
      }
    },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  /* height: 63020px; */
  background: #fff;
}

* {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  /* width: 86.7%;
  margin: 0px auto;
  height: 73980px; */
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 55px;
  font-weight: bold;
  color: #1d244e;
}

.header_titles .monthly {
  font-size: 40px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 40px 0 60px 0;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 25px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}

.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  position: relative;
  clear: both;
  font-weight: bold;
  font-size: 44px;
  color: #1d244e;
  margin: 35px 0;
}

.chart_box,
.catalogue h3 {
  font-weight: 700;
  font-size: 50px;
  color: #1d244e;
}

.chart_box h3 {
  font-size: 50px;
  margin-bottom: 35px;
}

.catalogue h3 {
  margin-bottom: 15px;
  margin-top: 50px;
  line-height: 40px;
}

.chart_box,
.catalogue h4 {
  font-weight: 700;
  font-size: 50px;
  color: #1d244e;
}

.chart_box h4 {
  font-size: 42px;
  margin-top: 35px;
  margin-bottom: 35px;
}

.catalogue h4 {
  margin-bottom: 15px;
  margin-top: 50px;
}

.chart_box,
.catalogue h5 {
  font-weight: 700;
  font-size: 45px;
  color: #1d244e;
}

.catalogue h5 {
  margin-bottom: 15px;
  margin-top: 50px;
  line-height: 40px;
}

.chart_box h5 {
  font-size: 40px;
  margin-top: 35px;
  margin-bottom: 35px;
}

.chart_box h6 {
  font-weight: 700;
  font-size: 39px;
  color: #1d244e;
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 50px;
}

.chart_box p {
  font-weight: 540;
  font-size: 35px;
  text-indent: 2em;
  line-height: 70px;
  color: #272a3f;
}

.chart_box .echartsHeight {
  /* width: 80%; */
  /* height: calc(100vw / 1080 * 300); */
  height: 400px;
  /* height:30rem; */
  margin: 10px auto 0px;
}

.chart_box .chart_name {
  font-weight: 540 !important;
  text-align: center;
  font-size: 32px;
  color: #272a3f;
  clear: both;
  /* margin-bottom: 40px; */
  margin-top: 20px;
}

.chart_box .notes {
  margin: 35px 0;
  line-height: 50px;
  font-size: 30px;
  color: black;
}

.export {
  width: 88px;
  height: 32px;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
}

.center {
  text-align: center;
}

.divorced {
  margin-top: 40px;
}

.biaoge {
  /* height: 720px; */
  font-weight: 540 !important;
  width: 97%;
  margin: 0px auto 25px;
  /* font-size: 16px !important; */
  color: #272a3f !important;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 45px;
  line-height: 45px;
  color: #707f9d;
  font-size: 22px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgba(73, 187, 233);

  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);
  color: #fff;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}

.HomePage {
  position: relative;
  padding-left: 10%;
  padding-top: 18%;
}

.HomePage #image {
  width: 559px;
  height: 70px;
  background: url("../../../../public/pdf_year.png") no-repeat;
  background-size: 100% 100%;
}

#PdfTitle {
  margin: 36% 0;
  padding: 20px 0px 20px 40px;
  position: relative;
  border-left: 3px solid #729ac0;
}

#FristTitle {
  font-size: 65px;
  font-weight: 700;
  margin-bottom: 40px;
}

#SecondTitle {
  font-size: 65px;
  font-weight: 600;
  margin-bottom: 40px;
}

#ThrendTitle {
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 40px;
}

#FourTitle {
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 40px;
}

#foot {
  display: flex;
}

.HomePage .footBox {
  flex-direction: column;
  display: flex;
  align-items: center;
  font-size: 42px;
  margin-left: 4.5%;
}

.HomePage #foot p {
  margin: 20px 0px;
}

/* 目录级别 */
.catalogue .title {
  text-align: center;
  margin-bottom: 4%;
  font-size: 40px;
}

.top {
  margin-top: 140px;
}
</style>
<style lang="scss" scoped>
.page-box {
  // padding: 7% 0;
  // height: 2740px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  // border: 1px solid red;
  .m-top150 {
    margin-top: 150px;
  }

  .m-top50 {
    margin-top: 50px;
  }

  .m-top100 {
    margin-top: 100px;
  }

  .biaoge {
    width: 95%;
    margin: 25px auto;

    .course {
      text-align: center;
      margin: 0px 10px;

      tr {
        height: 42px;
        color: #707f9d;
        font-size: 22px;

        &:nth-child(2n) {
          background: #fff;
          color: #566178;
        }

        &:nth-child(2n-1) {
          background: #7ed2ff;
          color: #566178;
        }
      }
    }
  }
}

.catalogue {
  position: relative;
  // padding: 10% 8%;

  .title {
    text-align: center;
    margin-bottom: 4%;
    font-size: 40px;
  }

  .Second_text {
    padding-left: 1.8em;
  }

  .Thred_text {
    padding-left: 7.69em;
  }

  h5 {
    display: flex;
    align-items: center;

    .dot {
      flex: 1;
      border-top: dotted #1d244e 7px;
      /* 可设置大小，查属性参数dotted可换其他样式 */
      margin: 0 10px;
      /* 用来控制文字与填充线的间隔大小 */
    }
  }
}

.flex-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.right {
  float: right;
  margin-right: 20px;
  font-size: 32px;
}
</style>
